module.exports = __webpack_public_path__ + "img/banner-img-paymi.0c4d5b60.png";